// Webpack Imports
//import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

//JQuery Custom Scripts

jQuery.noConflict();

(function ($) {
	// Adiciona o Jivo ao menu
	$(document).on('click', '.open-jivo a', function (e) {
		e.preventDefault();
		if (typeof jivo_api !== 'undefined' && jivo_api.open) {
			jivo_api.open();
		}
	});

	// Popup Flutuante
	if ($('#tarja-promo').length > 0 && $('#header').length > 0) {
		let alturaTarja = $('#tarja-promo').outerHeight();
		$('#header').css('top', alturaTarja + 'px');
		document.body.style.marginTop = alturaTarja + 'px'

		$('.close-btn').on('click', function () {
			$('#tarja-promo').hide();
			$('#header').css('top', '0px');
			document.body.style.marginTop = '0px'
		});
	}

	// Barra Progresso Single
	function adjustProgressBarPosition() {
		var navbarHeight = $('#header').outerHeight();
		$('#progressBarContainer').css('top', navbarHeight + 'px');
	}
	function updateProgressBar() {
		var article = $('.article-single');
		if (article.length == 0) { return }
		var articleHeight = article[0].scrollHeight;
		var articleTop = article.offset().top;
		var scrollTop = $(window).scrollTop();
		var windowHeight = $(window).height();

		if (scrollTop >= articleTop && scrollTop <= articleTop + articleHeight) {
			var progress = ((scrollTop - articleTop) / (articleHeight - windowHeight)) * 100;
			$('#progressBar').css('width', Math.min(progress, 100) + "%");
		} else if (scrollTop < articleTop) {
			$('#progressBar').css('width', "0%");
		} else {
			$('#progressBar').css('width', "100%");
		}
	}

	// Navbar
	$(window).scroll(function () {
		if ($(this).scrollTop() > 80) {
			$('#header').css('background-color', 'rgba(0, 0, 0, 1)');
			$('#header-light').css('background-color', 'rgba(255, 255, 255, 1)');
			$('#btn-teste').css({
				'background-color': '#8229F9',
				'color': '#fff',
				'transition': 'all 0.5s ease-in-out'
			});
			$('#btn-teste-light').css({
				'background-color': '#8229F9',
				'color': '#fff',
				'transition': 'all 0.5s ease-in-out'
			});
			if ($('#progressBar').length) {
				$('#progressBar').css('background-color', '#00bebe');
			}
		} else {
			$('#header').css('background-color', 'transparent');
			$('#btn-teste').css({
				'background-color': '#fff',
				'color': '#00c1b3',
				'transition': 'all 0.5s ease-in-out'
			});
			$('#btn-teste-light').css({
				'background-color': '#00bebe',
				'color': '#FFF',
				'transition': 'all 0.5s ease-in-out'
			});
			if ($('#progressBar').length) {
				$('#progressBar').css('display', 'transparent');
			}
		}
		updateProgressBar();
	});

	$(window).on('load', function () {
		adjustProgressBarPosition();
	});


	// Scroll Nav Produtos
	var links = $('.links-produtos').find('a');
	$(window).scroll(function () {
		if ($('#nav-produto').length > 0) {
			if ($(this).scrollTop() > 700) {
				$('#nav-produto').slideDown();
			} else {
				$('#nav-produto').slideUp();
			}
		}

		if (links.length > 0) {
			$('section').each(function () {
				if ($(this).offset() && $(this).offset().top <= $(window).scrollTop() + 200 && $(this).offset().top + $(this).height() > $(window).scrollTop()) {
					links.removeClass('active');
					let sectionId = $(this).attr('id');
					if (sectionId) {
						$('a[href="#' + sectionId + '"]').addClass('active');
					}
				}
			});
		}
	});
	$('#nav-produto a').click(function (e) {
		e.preventDefault();
		if ($('nav a').length > 0) {
			$('nav a').removeClass('active');
			$(this).addClass('active');
			let target = $($(this).attr('href'));
			if (target.length > 0) {
				$('html, body').animate({
					scrollTop: target.offset().top - 0
				}, 500);
			}
		}
	});
})(jQuery);

//Progress Bar
function initializeProgressBars(id) {
	let progressBars = document.getElementById(id);
	if (progressBars) {
		let buttons = progressBars.querySelectorAll('.btn');
		if (buttons.length > 0) {
			let currentBar = 0;
			let accordions = progressBars.querySelectorAll('.accordion-collapse');
			let pbqs = progressBars.querySelectorAll('.progress-bar');
			let pbqsp = progressBars.querySelectorAll('.progress');
			let cec = accordions.length;
			let changedTick;
			function changeProgressBar(n, t) {
				changedTick = t || performance.now();
				currentBar = n;
				let b = n % cec;
				for (let i = 0; i < cec; i++) {
					if (i == b) {
						accordions[i].classList.add('show');
						pbqsp[i].style.display = 'block';
					} else {
						accordions[i].classList.remove('show');
						pbqsp[i].style.display = 'none';
						pbqs[i].style.width = '0%';
					}
				}
			}
			for (let btn = 0; btn < buttons.length; btn++) {
				buttons[btn].addEventListener('click', function () {
					for (let i = 0; i < cec; i++) {
						if (i < btn) {
							pbqs[i].style.width = '100%';
						} else {
							pbqs[i].style.width = '0%';
						}
					}
					changeProgressBar(btn);
				})
			}
			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						changeProgressBar(0)
						setInterval(function () {
							let bar = pbqs[currentBar];
							if (bar) {
								let tick = performance.now();
								let timePassed = tick - changedTick;
								bar.style.width = timePassed / 45 + '%';
								if (timePassed > 5000) {
									changeProgressBar((currentBar + 1) % cec, tick)
								}
							}
						}, 100)
						observer.unobserve(entry.target);
					}
				});
			}, { threshold: 0.5 });
			observer.observe(progressBars);
		}
	}
}

$(document).ready(function () {
	initializeProgressBars('progress-bars-01');
	initializeProgressBars('progress-bars-01-mobile');
	initializeProgressBars('progress-bars-02');
	initializeProgressBars('progress-bars-02-mobile');
	initializeProgressBars('progress-bars-03');
	initializeProgressBars('progress-bars-03-mobile');
});

//Filters

jQuery(document).ready(function ($) {
	var selectedCategories = [];

	$('.btn-categorias').on('click', function (e) {
		e.preventDefault();
		var category = $(this).data('category');

		if (selectedCategories.includes(category)) {
			selectedCategories.splice(selectedCategories.indexOf(category), 1);
			$(this).removeClass('active');
		} else {
			selectedCategories.push(category);
			$(this).addClass('active');
		}

		loadPostsByCategory(selectedCategories.join(','), function (data) {
			$('#blog-posts').html(data);
			$('#load-more-btn').data('page', 2);
			$('#load-more-btn').data('category', selectedCategories.join(','));
			$('#load-more-btn').show();
			$('#no-more-posts').hide();
		});
	});


	$('#load-more-btn').on('click', function (e) {
		e.preventDefault();

		var category = $(this).data('category');
		var page = $(this).data('page');

		loadMorePosts(category, page, function (data) {
			if (data) {
				$('#blog-posts').append(data);
				$('#load-more-btn').data('page', page + 1);
			} else {
				$('#load-more-btn').hide();
				$('#no-more-posts').show();
			}
		});
	});
});


//Biblioteca

jQuery(document).ready(function ($) {

	var selectedSubjects = [];
	var selectedTypes = [];

	function updateLibraryPosts() {

		var filterDataSubjects = {
			subjects: selectedSubjects.join(','),
			types: '',
			taxonomy: 'wp_biblioteca-subjects'
		};

		var filterDataTypes = {
			subjects: '',
			types: selectedTypes.join(','),
			taxonomy: 'wp_biblioteca-types'
		};


		if (selectedSubjects.length > 0) {
			loadLibraryPosts(filterDataSubjects, function (data) {
				$('#biblioteca-posts-subjects').html(data);
			});
		} else {

			loadLibraryPosts({ subjects: '', types: '', taxonomy: 'wp_biblioteca-subjects' }, function (data) {
				$('#biblioteca-posts-subjects').html(data);
			});
		}


		if (selectedTypes.length > 0) {
			loadLibraryPosts(filterDataTypes, function (data) {
				$('#biblioteca-posts-types').html(data);
			});
		} else {

			loadLibraryPosts({ subjects: '', types: '', taxonomy: 'wp_biblioteca-types' }, function (data) {
				$('#biblioteca-posts-types').html(data);
			});
		}
	}



	$('.btn-subjects').on('click', function (e) {
		e.preventDefault();
		var subject = $(this).data('category');


		var index = selectedSubjects.indexOf(subject);
		if (index > -1) {
			selectedSubjects.splice(index, 1);
		} else {
			selectedSubjects.push(subject);
		}

		$(this).toggleClass('active');
		$('#load-more-subjects').data('page', 2);
		updateLibraryPosts();
	});


	$('.btn-types').on('click', function (e) {
		e.preventDefault();
		var type = $(this).data('category');


		var index = selectedTypes.indexOf(type);
		if (index > -1) {
			selectedTypes.splice(index, 1);
		} else {
			selectedTypes.push(type);
		}

		$(this).toggleClass('active');
		$('#load-more-types').data('page', 2);
		updateLibraryPosts();
	});


	$('#load-more-subjects').on('click', function (e) {
		e.preventDefault();
		var currentPage = $(this).data('page');


		loadMoreLibraryPosts(selectedSubjects, '', currentPage, 'wp_biblioteca-subjects', function (data) {
			if (data) {
				$('#biblioteca-posts-subjects').append(data);
				$('#load-more-subjects').data('page', currentPage + 1);
			} else {
				$('#load-more-subjects').hide();
				$('#no-more-posts-subjects').show();
			}
		});
	});


	$('#load-more-types').on('click', function (e) {
		e.preventDefault();
		var currentPage = $(this).data('page');


		loadMoreLibraryPosts('', selectedTypes, currentPage, 'wp_biblioteca-types', function (data) {
			if (data) {
				$('#biblioteca-posts-types').append(data);
				$('#load-more-types').data('page', currentPage + 1);
			} else {
				$('#load-more-types').hide();
				$('#no-more-posts-types').show();
			}
		});
	});

});


// Archive Loop

jQuery(function ($) {
	$('#load-more-archive').on('click', function (e) {
		e.preventDefault();
		var currentPage = $(this).data('page');
		var currentCategory = $(this).data('category');

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'load_more_by_category',
				page: currentPage,
				category: currentCategory
			},
			success: function (response) {
				if (response) {
					$('#blog-posts').append(response);
					$('#load-more-archive').data('page', currentPage + 1);
				} else {
					$('#load-more-archive').hide();
					$('#no-more-posts').show();
				}
			}
		});
	});
});

//Archive loop Biblioteca

jQuery(document).ready(function ($) {

	$('#load-more-archive-tax').click(function () {
		var button = $(this),
			data = {
				'action': 'load_more_posts_tax',
				'taxonomy': button.data('taxonomy'),
				'term': button.data('term'),
				'page': button.data('page')
			};

		$.post('/wp-admin/admin-ajax.php', data, function (response) {
			if (response) {
				$('#blog-posts').append(response);
				button.data('page', data.page + 1);
			} else {
				$('#load-more-archive-tax').hide();
				$('#no-more-posts').show();
			}
		});
	});

});

//Overlay do filtro da página Biblioteca

$(function () {
	let fb = $('.filter-button')
	fb.on('click', function (event) {
		event.stopPropagation();
		if (!this.classList.contains("collapsed")) {
			$('.overlay').fadeIn('fast');
		} else {
			$('.overlay').fadeOut('fast');
		}
	});
	$('.btn-categorias').on('click', function () {
		$('.overlay').fadeOut('fast');
	});
	$(document).on('click', function (event) {
		if (!$(event.target).closest('.filtros-bib').length) {
			$('.overlay').fadeOut('fast');
		}
	});
	$('.filtros-bib').on('click', function (event) {
		event.stopPropagation();
	});
});

//Altera a seção do filtro
$(function () {
	$('.section-conteudos').hide();
	$('[data-bs-target="#collapseOne"]').on('click', function () {
		$('.section-assuntos').show();
		$('.section-conteudos').hide();
	});

	$('[data-bs-target="#collapseTwo"]').on('click', function () {
		$('.section-conteudos').show();
		$('.section-assuntos').hide();
	});
});

//Subject Switch Buttons
$(function () {
	if ($('.btn-switch-subject').length > 0 && $('.btn-subjects').length > 0) {
		$('.btn-switch-subject').on('click', function (event) {
			let subj = this.getAttribute('subject');

			$('.btn-subjects').each(function (_, btn) {
				if (btn.getAttribute('data-category') === subj && !btn.classList.contains('active')) {
					btn.click();
				}
			});

			let section = document.getElementById("subjectSelectorSection");
			if (section) {
				section.scrollIntoView();
			}
		});
	}
});



//RD Popup Observer

(function () {
	const observer = new MutationObserver((mutations, obs) => {
		const floatingBar = document.querySelector('.floating-bar');
		if (floatingBar) {
			const closeButton = floatingBar.querySelector('.rdstation-popup-js-close-button');
			if (closeButton) {
				closeButton.addEventListener('click', () => {
					const header = document.getElementById('header');
					const headerLight = document.getElementById('header-light');

					if (header) {
						header.style.top = '0px';
					}
					if (headerLight) {
						headerLight.style.top = '0px';
					}
				});
				obs.disconnect();
			}
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
})();
